require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// /Users/jb/Code/grupob/~/core-js/modules/es7.symbol.observable.js
// module id = 328
// module chunks = 0